
import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data';

const SocialSidebar = () => {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-3 items-end">
      <a
        href={companyInfo.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#1877F2] text-white p-4 rounded-l-lg shadow-lg hover:pl-6 transition-all duration-300 flex items-center justify-center group"
        aria-label="Følg os på Facebook"
      >
        <Facebook size={24} className="group-hover:scale-110 transition-transform" />
      </a>
      <a
        href={companyInfo.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-gradient-to-tr from-[#f09433] via-[#e6683c] to-[#bc1888] text-white p-4 rounded-l-lg shadow-lg hover:pl-6 transition-all duration-300 flex items-center justify-center group"
        aria-label="Følg os på Instagram"
      >
        <Instagram size={24} className="group-hover:scale-110 transition-transform" />
      </a>
    </div>
  );
};

export default SocialSidebar;
